/**
 * The one message the chrome layer sends *to* the frontend. The cold client cannot log an exposure
 * (logging off, no network), so it names the key and the frontend's live client logs it. Shared here
 * because both halves must agree on the string and neither imports the other.
 */
export const LOG_FEATURE_GATE_EXPOSURE_MESSAGE_TYPE = 'LOG_FEATURE_GATE_EXPOSURE';

/**
 * The frontend route the extension's hidden relay page loads to log a surface's exposure when no
 * frontend is mounted beside it. Renders nothing, and only initialises the live Statsig client.
 */
export const EXPOSURE_RELAY_PATH = '/extension/exposure-relay';

export interface LogFeatureGateExposureMessage {
	readonly type: typeof LOG_FEATURE_GATE_EXPOSURE_MESSAGE_TYPE;
	/**
	 * An experiment key: a registered one, or one the frontend owns and the extension relays. Never a
	 * gate or a dynamic config; neither needs exposure.
	 */
	readonly key: string;
}

export function isLogFeatureGateExposureMessage(
	data: unknown,
): data is LogFeatureGateExposureMessage {
	return (
		typeof data === 'object' &&
		data !== null &&
		(data as { type?: unknown }).type === LOG_FEATURE_GATE_EXPOSURE_MESSAGE_TYPE &&
		typeof (data as { key?: unknown }).key === 'string'
	);
}

/**
 * Sent by the extension's hidden relay page after the last exposure message, so the frontend flushes
 * its event queue before the page closes. Without it an exposure waits for the SDK's flush interval.
 */
export const FLUSH_FEATURE_GATE_EXPOSURES_MESSAGE_TYPE = 'FLUSH_FEATURE_GATE_EXPOSURES';

export interface FlushFeatureGateExposuresMessage {
	readonly type: typeof FLUSH_FEATURE_GATE_EXPOSURES_MESSAGE_TYPE;
}

export function isFlushFeatureGateExposuresMessage(
	data: unknown,
): data is FlushFeatureGateExposuresMessage {
	return (
		typeof data === 'object' &&
		data !== null &&
		(data as { type?: unknown }).type === FLUSH_FEATURE_GATE_EXPOSURES_MESSAGE_TYPE
	);
}
